import { render } from "./BinWang.vue?vue&type=template&id=9ca2be94&scoped=true"
import script from "./BinWang.vue?vue&type=script&lang=js"
export * from "./BinWang.vue?vue&type=script&lang=js"

import "./BinWang.vue?vue&type=style&index=0&id=9ca2be94&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ca2be94"]])

export default __exports__